import { render, staticRenderFns } from "./OptionProductSelectDialog.vue?vue&type=template&id=663bb2a0&scoped=true"
import script from "./OptionProductSelectDialog.vue?vue&type=script&lang=js"
export * from "./OptionProductSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./OptionProductSelectDialog.vue?vue&type=style&index=0&id=663bb2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663bb2a0",
  null
  
)

export default component.exports